export const calendarTypes = {
    BACKEND: 'BACKEND'
};
